
export const useCommentCount = (count: number) => {
    const renderCommentText = () => {
        return `${count <= 0 ? '' : count } ${count > 1 ? 'Comments' : 'Comment'}`
      }

    return {
        renderCommentText
    } as const
}